import { IRankingRepository } from '../../domain/repositories/IRankingRepository';
import { DailyStreakDTO } from '../dto/RankingDTO';
import { RankingMapper } from '../mappers/RankingMapper';

export class GetStreakUseCase {
  constructor(private readonly repository: IRankingRepository) {}

  async execute(studentId: string): Promise<DailyStreakDTO> {
    const streak = await this.repository.getDailyStreak(studentId);
    return RankingMapper.toDailyStreakDTO(streak);
  }
}
